import Vue from 'vue'
import Vuex from 'vuex'
import hijri from 'moment-hijri';
import Utils from '~/lib/Utils';
import PrayerService from '~/lib/PrayerService';

Vue.use(Vuex)

let prayerService = new PrayerService();
export default new Vuex.Store({
  state: {
    time: new Date(), // updates every second
    date: new Date(), // updates every minute
    location: null,
    error: null,
    settings: null,
    prayerService,

    prayerCalculatingMethods: {
      MWL: 'Muslim World League',
      ISNA: 'Islamic Society of North America',
      Egypt: 'Egyptian General Authority of Survey',
      Makkah: 'Umm al-Qura University, Makkah',
      Karachi: 'University of Islamic Sciences, Karachi',
      Tehran: 'Institute of Geophysics, University of Tehran',
      Jafari: 'Shia Ithna Ashari (Ja`fari)'
    },

    prayerTimeNames: {
      fajr : 'Fajr',
      sunrise: 'Sunrise',
      dhuhr: 'Zuhur',
      asr: 'Asr',
      maghrib: 'Maghrib',
      isha: 'Isha',
      midnight: 'Midnight'
    },
  },
  
  getters: {
    hijri(state) {
      hijri(state.time);
    },

    minute(state) {
      return state.time.getMinutes()
    },

    settings(state) {
      if(!state.settings) {
        let settings = Utils.getCookie('settings');
        if(settings) {
          console.log('settings found in cookie', settings);
          state.settings = JSON.parse(settings);
        } else {
          state.settings = { // defaults
            method: 'ISNA',
            asr: 'Standard'
          };
        }
      }

      return state.settings;
    },

    /**
     * Get location
     * 
     * @param {any} state 
     * @returns 
     */
    location(state) {
      if(!state.location) {
        let location = Utils.getCookie('location');
        if(location) {
          console.log('location found in cookie', location);
          state.location = JSON.parse(location);
        }
      }

      // return null;
      return state.location;
    },

    prayerTimes(state, getters) {
      let location = getters.location;
      if(!location) return null;

      return prayerService.getTimes(state.date, [location.lat, location.lng],
        Object.assign({}, getters.settings, {
          format: '24h'
        }));
    },

    currentPrayerNameAndTime(state, getters) {
      let times = getters.prayerTimes;
      // times = {
      //   asr : "10:16",
      //   dhuhr : "10:13",
      //   fajr: "04:12",
      //   imsak: "04:02",
      //   isha: "22:16",
      //   maghrib: "15:26",
      //   midnight: "01:14",
      //   sunrise: "05:51",
      //   sunset: "20:37"
      // }
      // console.log('times calculated', times);
      
      if(!times) return;
      let date = new Date();
      date.setHours(state.date.getHours(), state.date.getMinutes(), 0);
      date.setMilliseconds(0);

      let current = {}, next = {};
      for(let name in state.prayerTimeNames) {
        let time = times[name];
        let [hour, minute] = time.split(':').map(Number);
        
        // console.log('time:', name, time);
        let pdate = new Date();
        pdate.setHours(hour, minute, 0);
        pdate.setMilliseconds(0);
        pdate.setSeconds(0);

        //@hack
        if(name === 'midnight') {
          pdate.setDate(pdate.getDate() + 1);
        }
        
        if(date > pdate) { // 
          current.name = name;
          current.date = pdate;
        } else if( date < pdate) {
          next.name = name;
          next.date = pdate;
          break;
        } else {
          current.name = name;
          current.date = pdate;
          // break;
          console.log('bad logic');
        }
      }

      return [current, next];
    },

    googleClient() {
      console.log('requested google client');
      return require('@google/maps').createClient({
        key: 'AIzaSyBCdZBUAhjh9C7xDvXdKos065gJGl-LKbA',
        Promise: Promise
      });
    }
  },

  mutations: {
    /**
     * 
     * 
     * @param {any} state 
     * @param {any} settings 
     */
    settings(state, settings) {
      let copy = Object.assign({}, settings);
      console.log('mutatinig setting', copy);
      state.settings = copy;
      Utils.setCookie('settings', copy);
    },

    /**
     * Sets location
     * 
     * @param {any} state 
     * @param {any} location 
     */
    location(state, location) {
      let loc = {
        lat: location.lat || location.latitude,
        lng: location.lng || location.longitude,
        timestamp: location.timestamp || Date.now()
      };
      state.location = loc;
      Utils.setCookie('location', loc);
    },

    /**
     * Set global error state
     * 
     * @param {any} state 
     * @param {any} error 
     */
    error(state, error) {
      state.error = error
    }
  },

  actions: {
    init({commit, state, getters, dispatch}) {
      // initialize settings

      // attempt to get location if not found
      if(!getters.location) {
        console.log('location info NOT found in cookie or local. attempt to ask user');
        dispatch('locate');
      }

      // start the time
      setInterval(() => {
        state.time = new Date();
        if(state.date.getMinutes() !== state.time.getMinutes()) {
          state.date = new Date();
        }

      }, 1* 1000);
    },

    locate({ commit }) {
      // attempt to get location using geo api
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('obtained position from geo api', position);
          commit('location', position.coords);
        },

        (error) => {
          console.log('geo api error', error);
          commit('error', error);
        }
      );
    },

    async geocode({ commit, state, getters}, address) {
      try {
        let response = await getters.googleClient.geocode({address: address}).asPromise();
        let location = response.json.results[0].geometry.location;
  
        commit('location', {
          lat: location.lat,
          lng: location.lng,
          timestamp: Date.now()
        });
      } catch(e) {
        state.error = e;
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js